export class DateReqForDashBoard{
    divisionId : number;
    clientCode : string;
}